module.exports = __webpack_public_path__ + "banquet/components/AppStoreBadges/images/apple_app_store_2x.452c7b1bc1ff81ba275954734ec77a68.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AppStoreBadges/images/apple_app_store_2x.png
// module id = 1650
// module chunks = 1